<form name="contactForm"
      class="ps-4 pe-4 pt-2"
      [formGroup]="contactForm"
      novalidate>
  <div class="row g-2 mb-3">
    <div class="col-md-2">
      <label>Title</label>

      <select class="form-select"
              id="basic-addon1"
              formControlName="salutation"
              [ngClass]="{
              'form-required-border':
                contactForm.get('salutation').invalid &&
                contactForm.get('salutation').touched
            }">
        <option value="" selected="selected">
          {{ "Select Title..." }}
        </option>
        <option *ngFor="let salutation of salutations"
                value="{{ salutation }}">
          {{ salutation }}
        </option>
      </select>
    </div>

    <div class="col-4">
      <label>First name</label>
      <input type="text"
             class="form-control"
             [ngClass]="{
              'form-required-border':
                contactForm.get('firstName').invalid &&
                contactForm.get('firstName').touched
            }"
             formControlName="firstName"
             placeholder="First name" />
    </div>
    <div class="col-4">
      <label>Last name</label>
      <input type="text"
             class="form-control"
             [ngClass]="{
              'form-required-border':
                contactForm.get('lastName').invalid &&
                (contactForm.get('lastName').dirty ||
                  contactForm.get('lastName').touched)
            }"
             formControlName="lastName"
             placeholder="Last name" />
    </div>
    <div class="col-2">
      <label>Suffix</label>
      <input type="text"
             class="form-control"
             [ngClass]="{
      'form-required-border':
        contactForm.get('suffix').invalid &&
        contactForm.get('suffix').touched
    }"
             formControlName="suffix"
             placeholder="Suffix" />
    </div>
  </div>
  <div class="row g-2">
    <div class="col-6">
      <label>Email</label>
      <input type="email"
             class="form-control"
             [ngClass]="{
              'form-required-border':
                contactForm.get('email').invalid &&
                (contactForm.get('email').dirty ||
                  contactForm.get('email').touched)
            }"
             formControlName="email"
             placeholder="Email Address" />
    </div>
    <div class="col-6">
      <label>Mobile </label>

      <!--<span class="input-group-text bg-white" id="basic-addon1">
         <i class="fas fa-phone"></i>
       </span>

       <select *ngIf="countries.length > 0"
               class="form-select"
               style="flex: 1; border-top-left-radius: 0; border-bottom-left-radius: 0;"
               formControlName="countryCode"
               [ngModelOptions]="{ standalone: true }">
         <option *ngFor="let country of countries" [value]="country?.code">
           {{ country?.countryName }} ({{ country?.code }})
         </option>
       </select>

       <input type="text"
              class="form-control"
              style="flex: 2;"
              [ngClass]="{
        'form-required-border': contactForm.get('mobile').invalid &&
        (contactForm.get('mobile').dirty || contactForm.get('mobile').touched)
      }"
                [selectedCountryISO]="CountryISO.India"
              formControlName="mobile"
              placeholder="Mobile" />-->

      <ngx-intl-tel-input #phoneInput [cssClass]="'form-control'"
                          [preferredCountries]="preferredCountries"
                          [enableAutoCountrySelect]="true"
                          [enablePlaceholder]="true"
                          [searchCountryFlag]="true"
                          [searchCountryField]="[
                              SearchCountryField.Iso2,
                              SearchCountryField.Name,
                              SearchCountryField.DialCode
                            ]"
                          [selectFirstCountry]="false"
                          [(selectedCountryISO)]="selectedCountryISO"
                          [maxLength]="15"
                          [phoneValidation]="true"
                          [separateDialCode]="true"
                          [numberFormat]="PhoneNumberFormat.National"
                          name="mobile"
                          formControlName="phone">
      </ngx-intl-tel-input>

      <!--<app-intl-tel-input class="form-group"
                                  style="display: block;"
                                  formControlName="mobile"
                                  [countryCode]="contactForm.get('countryCode')?.value"
                                  (countryCodeChange)="contactForm.get('countryCode')?.setValue($event)"
                                  inputClass="form-control"
                                  [inputStyle]="{ flex: 2 }"
                                  [inputNgClass]="{
        'form-required-border': contactForm.get('mobile')?.invalid &&
                                (contactForm.get('mobile')?.dirty || contactForm.get('mobile')?.touched)
      }"
                                  [initialCountry]=""></app-intl-tel-input>-->

    </div>

  </div>
  <div class="row g-2">
    <div class="col-6" *ngIf="isShowOrgDropDown">
      <label>{{ OrgTitle }}</label>
      <select [(ngModel)]="selectedBusinessId"
              [ngModelOptions]="{standalone: true}"
              name="orgDropdown"
              class="form-select"
              aria-label="Select Org">
        <option [ngValue]="0">
          Select {{OrgTitle}}...
        </option>
        <option *ngFor="let org of repoBusinesses"
                [ngValue]="org.repoBusinessId">
          {{ org.businessName }}
        </option>
      </select>
    </div>

    <div class="col-6">
      <label>Position</label>
      <select formControlName="positionId"
              class="form-select"
              [ngClass]="{
      'form-required-border':
        contactForm.get('positionId').invalid &&
        (contactForm.get('positionId').dirty ||
          contactForm.get('positionId').touched)
    }"
              placeholder="Select Position..."
              aria-label="Select Position">
        <option value="0">
          Select position...
        </option>
        <option *ngFor="let position of positionList"
                [ngValue]="position.positionId">
          {{ position.positionName }}
        </option>
      </select>
    </div>
    <div class="col-auto" *ngIf="isShowRepoMailCheckboxes; else hiddenInputs">
      <mat-checkbox class="me-1" formControlName="isReceiveRepoEmail">
        <mat-label>Receive Email</mat-label>
      </mat-checkbox>

      <mat-checkbox class="me-1" formControlName="isReceiveRepoSMS">
        <mat-label>Receive SMS</mat-label>
      </mat-checkbox>
    </div>

    <ng-template #hiddenInputs>
      <input type="hidden" formControlName="isReceiveRepoEmail" />
      <input type="hidden" formControlName="isReceiveRepoSMS" />
    </ng-template>

    <!--<div class="col-auto">
    <br />
    <button
      type="button"
      class="btn btn-outline-primary btn-sm"
      (click)="openPositionDialog()"
    >
      <i
        class="fa fa-edit"
        *ngIf="contactForm.get('positionId').value > 0"
      >
      </i>
      <span *ngIf="contactForm.get('positionId').value > 0"> Edit</span>
      <i
        class="fa fa-plus"
        *ngIf="contactForm.get('positionId').value == 0"
      >
      </i
      ><span *ngIf="contactForm.get('positionId').value == 0"> Add</span>
      Position
    </button>
  </div>-->
  </div>


</form>
